<template lang="html">
  <div class="si-report" v-scroll="onScroll">
    <v-container
      grid-list-md
      pa-0
      class="si-report-container"
    >
      <v-layout
        justify-center
        ma-0
        pa-0
      >
        <v-flex
          xs12
          :md10="!dialog"
          :lg8="!dialog"
          pa-0
          pb-8
          class="si-report-wrapper"
        >
          <v-expand-transition>
            <si-report-sharing 
              v-if="showShare && viewSharing"
              :calculator-id="calculatorId" 
              :calculation-id="calculationId" 
              :sharing="sharing" 
              class="no-print"
              @update:sharing="v => $emit('update:sharing', v)"
              @hide="viewSharing = false"
            />
          </v-expand-transition>
            
          <v-progress-linear
            :indeterminate="true"
            :active="loading"
            height="2"
            class="ma-0 no-print"
          />
          <v-slide-y-transition>
            <v-card
            ref="report"
              v-if="!loading"
              class="si-report-page"
              :flat="$vuetify.breakpoint.smAndDown || dialog"
            >
              <v-layout
                column
                ma-0
                pb-5
              >
                <SiLogo
                  size="28"
                  class="si-hide-small-screen"
                />

                <v-flex
                  px-0
                  py-4
                  class="display-1 font-weight-light"
                >
                  {{ template.title }}
                </v-flex>

                <report-section-all-value-bar :data="data" />

                <v-flex
                  v-for="section in _sortObject(template.sections)"
                  :key="section.id"
                  pa-0
                >
                  <ReportSection
                    v-if="_show(section.condition)"
                    :data="data"
                    :section="section"
                    class="mb-4"
                  />
                </v-flex>


                <v-flex
                  px-0
                  pt-4
                >
                  <v-flex
                    v-if="report.clientReference"
                    xs12
                    px-0
                    pt-2
                  >
                    <div class="caption grey--text">
                      Your Reference
                    </div>
                    <div class="body-1">
                      {{ report.clientReference }}
                    </div>
                  </v-flex>
                  <v-flex
                    xs12
                    px-0
                    pt-2
                  >
                    <div class="caption grey--text">
                      Calculation Id
                    </div>
                    <div class="body-1">
                      {{ details.calculationId }}
                    </div>
                  </v-flex>
                  <v-flex
                    xs12
                    px-0
                    pt-2
                  >
                    <div class="caption grey--text">
                      Calculation Date
                    </div>
                    <div class="body-1">
                      {{ _formatDateTime(details.timestamp) }}
                    </div>
                  </v-flex>
                  <v-flex
                    xs12
                    px-0
                    mt-4
                  >
                    <v-layout
                      align-center
                      ma-0
                    >
                      <v-icon
                        left
                        color="primary"
                      >
                        link
                      </v-icon>
                      <a href="https://superinfo.com.au">superinfo.com.au</a>
                    </v-layout>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-card>
          </v-slide-y-transition>
        </v-flex>
      </v-layout>
    </v-container>
    <div
      class="no-print"
      :style="`
        position: fixed;
        top: ${toolbarHeight/2}px;
        transform: translateY(-50%);
        right: 0;
        z-index: 400;
      `"
    >
      <v-flex>
        <v-slide-y-reverse-transition>
          <v-btn 
            v-if="showShare && (!viewSharing || showShareButton)" 
            text
            color="blue white--text no-print" 
            style="z-index:202"
            @click="showSharing"
          >
            <v-icon left>
              share
            </v-icon>
            Share report
          </v-btn>
        </v-slide-y-reverse-transition>
  
        <v-btn
          v-if="!dialog"
          text
          color="primary"
          class="no-print mx-2"
          style="z-index:201"
          @click="printReport"
        >
          <v-icon left>
            print
          </v-icon>
          Print
        </v-btn>
      </v-flex>
    </div>



    <!-- <v-scale-transition>
      <v-btn 
        v-if="showShare && !viewSharing" 
        color="blue white--text no-print" 
        fab
        bottom
        right
        fixed  
        style="z-index:202; bottom: 88px"
        @click="viewSharing = true"
      >
        <v-icon>share</v-icon>
      </v-btn>
    </v-scale-transition> -->

    <!-- <v-menu
      :value="showShare && showSharePrompt"
      top
      left
      offset-y
      offset-x
    >
      <template #activator="{ on }">
        <div
          style="position: fixed; bottom: 160px; right: 16px"
          v-on="on"
        />
      </template>

      <v-card
        color="blue"
        dark
        max-width="300"
      >
        <v-card-title>
          Share your report<v-spacer /><v-btn
            icon
            @click="showSharePrompt = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="white--text">
          Now you can securely share your report to anyone's email address.
        </v-card-text>
      </v-card>
    </v-menu> -->

    <!-- <v-btn
      v-if="!dialog"
      fab
      dark
      fixed
      bottom
      right
      color="primary"
      class="no-print"
      style="z-index:201"
      @click="printReport"
    >
      <v-icon dark>
        print
      </v-icon>
    </v-btn> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import helpers from '@/mixins/helpers'
import conditions from '@/mixins/conditions'
export default {
  mixins: [ helpers, conditions ],
  props: {
    report: {
      type: Object,
      default: () => { return {} }
    },
    calculatorId: String, 
    calculationId: String, 
    sharing: {
      type: Object,
      default: () => ({})
    }, 
    dialog: Boolean,
    loading: Boolean,
    isRestricted: Boolean,
  },
  data: () => ({
    viewSharing: false, 
    showShareButton: false,
    // showSharePrompt: false,
  }),
  computed: {
    ...mapGetters(['_reportIsAdmin']),
    cData () {
      let obj = (this.data.report || {}).data || {}
      return Object.assign({}, ...Object.keys(obj).map(k => ({ [k]: obj[k].value })))
    },
    details () {
      return this.report.details || {}
    },
    template () {
      return this.report.template || {}
    },
    data () {
      return this.report.data || {}
    },
    isOwner () {
      return !!this.sharing.owner
    },
    showShare () {
      return (this._reportIsAdmin || this.isOwner) && this.isRestricted && !this.loading ///&& !this.viewSharing
    },
    toolbarHeight () {
      return this.$vuetify.breakpoint.smAndDown ? 56 : 64
    }
  },
  watch: {
    'template.title' () {
      this.setDocTitle()
    },
    'details.calculationId' () {
      this.setDocTitle()
    },
    // loading (v) {
    //   if (!v && Number(new Date()) < 1609372800000) {
    //     setTimeout(() => {
    //       this.showSharePrompt = true
    //       setTimeout(() => {this.showSharePrompt = false}, 5000);
    //     }, 500);
    //   }
    // }
  },
  beforeDestroy () {
    document.title = process.env.VUE_APP_DEFAULT_DOC_TITLE
  },
  methods: {
    printReport () {
      window.print()
    },
    showSharing () {
      this.viewSharing = true
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    setDocTitle () {
      let title = this.template.title && this.details.calculationId
        ? `Super Info - ${this.template.title} - ${this.details.calculationId}`
        : process.env.VUE_APP_DEFAULT_DOC_TITLE
      document.title = title
    },
    onScroll(e) {
      console.log(this.$refs.report.$el.getBoundingClientRect().top);
      console.log(e.target.scrollingElement.scrollTop);
      console.log(this.$refs.report.$el.getBoundingClientRect().top < this.toolbarHeight);
      if (this.$refs.report.$el) {
        this.showShareButton = this.$refs.report.$el.getBoundingClientRect().top < this.toolbarHeight
      }
    }
  }
  
}
</script>

<style lang="scss">
@media print {
  .theme--light.application {
    background-color: #fff !important;
  }
  .si-stop-children-breaking{
    .child-flex>*, .flex {
      display: table;
      break-inside: avoid;
      page-break-inside: avoid;
    }
    tr, td {
      break-inside: avoid;
      page-break-inside: avoid;
    }
  }
}
.si-report {
  .si-report-container {
    @media print {
      margin: 0 !important;
      max-width: 100% !important;
    }
  }
  .si-report-wrapper {
    @media print {
      max-width: 100% !important;
      flex-basis: 100% !important;
    }
    @media screen {
      max-width: 21cm !important;
    }
  }
  .si-report-page {
    @media print {
        border: none !important;
        box-shadow: none !important;
        padding-right: 0;
        padding-left: 0;
        padding-top: 0;
    }
    @media screen {
      padding-right: 32px;
      padding-left: 32px;
      padding-top: 16px;
    }
  }
}
@media only screen and (max-width: 960px) {
  .si-hide-small-screen {
    display: none;
  }
}
</style>
